module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-1.06971df0.svg";